export default __webpack_public_path__ + "static/mission-e4aec7cdc639b747c07d6aaad642ce6a.gif";